import React, { useEffect, useRef } from "react";

const Technologia = () => {
  const titleRef = useRef(null);
  const paraRef = useRef(null);
  const datadetailRef = useRef(null);
  const imgRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          } else {
            // Remove class when element goes out of view so it re-triggers on scroll again
            entry.target.classList.remove("visible");
          }
        });
      },
      {
        threshold: 0.2,
        rootMargin: "0px 0px -100px 0px",
      }
    );

    const elements = [
      titleRef.current,
      paraRef.current,
      datadetailRef.current,
      imgRef.current,
    ];
    elements.forEach((el) => el && observer.observe(el));

    return () => {
      elements.forEach((el) => el && observer.unobserve(el));
    };
  }, []);

  return (
    <div className="container-fluid  pb-5">
      <div className="container">
        <div className="row">
          <div
            ref={titleRef}
            className="title_line text-center p-5 animate-title"
          >
            Our Technology
          </div>
          <div>
            <p ref={paraRef} className="text-center animate-para">
              Solving problems with cutting-edge technologies.
              <br />
              At TechnoServe, a trusted tech consulting firm, we leverage the
              best emerging tools and technologies to deliver the right
              solutions the first time. Each technology is chosen with purpose,
              so we can stay swift, secure, and sustainable.
            </p>
          </div>
          <div className="col-md-12 mt-4">
            <div className="row">
              <div className="col-xl-2 col-lg-2 col-md-2 col-6  text-center p-3">
                <img src="/techno/react_ico.png" />
                <div className="text-center title_techno">React</div>
              </div>

              <div className="col-xl-2 col-lg-2 col-md-2 col-6   text-center p-3">
                <img src="/techno/angular_ico.png" />
                <div className="text-center title_techno">Angular</div>
              </div>
              <div className="col-xl-2 col-lg-2 col-md-2 col-6   text-center p-3">
                <img src="/techno/html_ico.png" />
                <div className="text-center title_techno">HTML</div>
              </div>
              <div className="col-xl-2 col-lg-2 col-md-2 col-6  text-center  p-3">
                <img src="/techno/sass_ico.png" />
                <div className="text-center title_techno">SASS</div>
              </div>
              <div className="col-xl-2 col-lg-2 col-md-2 col-6   text-center  p-3">
                <img src="/techno/dotnet_ico.png" />
                <div className="text-center title_techno">Dot Net</div>
              </div>
              <div className="col-xl-2 col-lg-2 col-md-2 col-6   text-center  p-3">
                <img src="/techno/pithon_ico.png" />
                <div className="text-center title_techno">Python</div>
              </div>
              <div className="col-xl-2 col-lg-2 col-md-2 col-6   text-center  p-3">
                <img src="/techno/nodejs_ico.png" />
                <div className="text-center title_techno">Node.js</div>
              </div>
              {/* <div className="col-md-1  text-center">
                <img src="/techno/php_ico.png" />
                <div className="text-center title_techno">PHP</div>
              </div> */}
              <div className="col-xl-2 col-lg-2 col-md-2 col-6   text-center  p-3">
                <img src="/techno/micro_ico.png" />
                <div className="text-center title_techno">Microsoft</div>
              </div>
              <div className="col-xl-2 col-lg-2 col-md-2 col-6   text-center  p-3">
                <img src="/techno/azure_ico.png" />
                <div className="text-center title_techno">Azure</div>
              </div>
              <div className="col-xl-2 col-lg-2 col-md-2 col-6  text-center  p-3">
                <img src="/techno/aws_ico.png" />
                <div className="text-center title_techno">AWS</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Technologia;
